
import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import Home from './pages/Home';
import Aboutus from './pages/AboutUs.js';
import MissionVision from './pages/MissionVision.js';
import TestingPage from './pages/TestingPage.js';
import ManufacturingPage from './pages/ManufacturingPage.js';
import Qualitypage from './pages/Qualitypage.js';
import ResearchPage from './pages/ResearchPage.js';
import CertificationPage from './pages/CertificationPage.js';
import ContactPage from './pages/ContactPage.js';
import CareerPage from './pages/CareerPage.js'
import IndigenouslyDevelopedAssemblies from './pages/IndegeniselyDevelopedSeals.js';
import CoatingandPlating from './pages/CoatingandPlating.js';
import PistonRodSeals from './pages/PistonRodSeals.js';
import MetallicFaceSeals from './pages/MetallicFaceSeals.js';
import PrecisionComponentOne from './pages/PrecisionComponentOne.js';
import PrecisionComponentTwo from './pages/PrecisionComponentTwo.js';
import ProductsPage from './pages/ProductsPage.js';
import CapabilitiesPage from './pages/CapabilitiesPage.js';
import PolicyPage from './pages/PolicyPage.js';
import CookieConsent from './components/Layout/CookieConsent.js';

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
}

function App() {
  return (
    <div className="App">
     <Routes>
     <Route path="/" element={<Home />} />
     <Route path="/products" element={<ProductsPage />} />
     <Route path="/capabilities" element={<CapabilitiesPage />} />
     <Route path="/aboutus" element={<Aboutus/>} />
     <Route path="/mission-vision" element={<MissionVision/>} />
     <Route path="/testing" element={<TestingPage/>} />
     <Route path="/manufacturing" element={<ManufacturingPage/>} />
     <Route path="/quality" element={<Qualitypage/>} /> 
     <Route path="/research" element={<ResearchPage/>} /> 
     <Route path="/certification" element={<CertificationPage/>} /> 
     <Route path="/piston-rod-seals" element={<PistonRodSeals />} />
     <Route path="/metallic-face-seals" element={<MetallicFaceSeals />} />
     <Route path="/indigenously-developed-assemblies" element={<IndigenouslyDevelopedAssemblies />} />
     <Route path="/coating-and-plating" element={<CoatingandPlating />} /> 
     <Route path="/precision-component" element={<PrecisionComponentOne />} /> 
     <Route path="/assemblies" element={<PrecisionComponentTwo />} /> 
     <Route path="/career" element={<CareerPage/>} /> 
     <Route path="/contact" element={<ContactPage/>} /> 
     <Route path="/privacy-policy" element={<PolicyPage/>} />
     <Route path="/cookie-policy" element={<PolicyPage/>} />
     <Route path="/terms-and-conditions" element={<PolicyPage/>} />
     <Route path="/code-of-conduct" element={<PolicyPage/>} />
     </Routes>
     <ScrollToTop />
     <CookieConsent />
    </div>
  );
}

export default App;
